'use client';

import { useEffect } from 'react';

import { Button } from '@/components/button/Button.component';

import { logError } from '../../helpers/error-handling';

import styles from './ErrorWrapper.module.scss';

export default function ErrorWrapper({
    error,
    reset,
}: {
    error: Error & { digest?: string };
    reset: () => void;
}) {
    useEffect(() => {
        logError('error boundary example', error);
    }, [error]);

    return (
        <div className={styles.error}>
            <p className={styles.message}>Something went wrong!</p>
            <p>
                {error.name}: {error.message} {error.digest}
            </p>
            <Button className={styles.action} onClick={() => reset()}>
                Try again
            </Button>
        </div>
    );
}
